import {Cover} from "../../../../../model2/task/properties/cover"
import {CoverType} from "../../../cover-type"

export const COVER_GALLERY_VERSION = 1 // change this value if gallery images are changed to prevent loading cached

export default function getCoverGalleryItems() {

    const initCoverGalleryItems = (path: string, name: string, length: number) => {
        let res = []
        for(let i = 1; i <= length; i++) {
            res.push(new Cover({
                type        : CoverType.GALLERY,
                id          : '{0}-{1}'.f(name, i),
                url         : '{0}/{1}-{2}.png'.f(path, name, i),
                thumbnail   : '{0}/{1}-{2}-thumbnail.png'.f(path, name, i),
            }))
        }
        return res
    }

    // !!!CAUTION!!! covers urls may be used by some users, change carefully
    return [{
        title: 'Abstraction',
        items: initCoverGalleryItems('abstraction', 'abstraction', 6)
    }, {
        title: 'Technology',
        items: initCoverGalleryItems('technology', 'technology', 6)
    }, {
        title: 'Gradients',
        items: initCoverGalleryItems('gradients', 'gradients', 6)
    }, {
        title: 'Art',
        items: initCoverGalleryItems('art', 'art', 6)
    }, {
        title: 'Music',
        items: initCoverGalleryItems('music', 'music', 6)
    }, {
        title: 'Sport',
        items: initCoverGalleryItems('sport', 'sport', 6)
    }, {
        title: 'Nature',
        items: initCoverGalleryItems('nature', 'nature', 9)
    }, {
        title: 'Architecture',
        items: initCoverGalleryItems('architecture', 'architecture', 6)
    }, {
        title: 'Food and drinks',
        items: initCoverGalleryItems('food-and-drinks', 'food-and-drinks', 6)
    }]
}

